<template>
  <v-container fluid>
    <v-card class="elevation-2 py-0 px-2 mt-4 rounded-lg">
      <v-row class="px-4 pb-0 pt-3">
        <v-col cols="10" sm="5" class="pb-0" style="padding-bottom: 20px!important">
          <v-text-field
              dense
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              outlined
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-col>
        <v-btn 
          color="#3F51B5" 
          class="mt-3" 
          dark 
          depressed 
          height='40'
          max-width='40'
          min-width='40'
          @click="cleanFilters"
        >
            <v-icon>
                mdi-autorenew
            </v-icon>
        </v-btn>
      </v-row>
      <v-row>
        <div class="ml-4">
          <div class="ml-4" style="display: inline-block">
            <b style="display: inline-block">Orders:</b>
            <v-select class="ml-2" style="display: inline-block; width: 50px" :items="['<=', '>=', '=']" v-model="orderCondition"/>
            <v-text-field  class="ml-2" style="display: inline-block; width: 80px" v-model="orderValue" type="number" min="0"/>
          </div>
          <div class="ml-4" style="display: inline-block">
            <b style="display: inline-block">Gallons:</b>
            <v-select class="ml-2" style="display: inline-block; width: 50px" :items="['<=', '>=', '=']" v-model="gallonCondition"/>
            <v-text-field  class="ml-2" style="display: inline-block; width: 80px" v-model="gallonValue" type="number" min="0"/>
          </div>
          <div class="ml-4" style="display: inline-block">
            <b style="display: inline-block">Inactivity Days:</b>
            <v-select class="ml-2" style="display: inline-block; width: 50px" :items="['<=', '>=', '=']" v-model="inactivityCondition"/>
            <v-text-field  class="ml-2" style="display: inline-block; width: 80px" v-model="inactivityValue" type="number" min="0"/>
          </div>

           <v-btn

            color="indigo"
            height="40"
            class="text--white ml-4"
            dark
            @click="hiddenAdditionalFilters = !hiddenAdditionalFilters"
          >
            {{ hiddenAdditionalFilters ? 'Show others' : 'Hide others' }}
          </v-btn>

        </div>
        <div class="ml-4" v-if="!hiddenAdditionalFilters">
          <div class="ml-4" style="display: inline-block">
            <b style="display: inline-block">Last Sale:</b>
            <v-select class="ml-2" style="display: inline-block; width: 50px" :items="['<=', '>=', '=']" v-model="saleCondition"/>
            <DateFilter class="ml-2" style="display: inline-block;" @getDates="(e) => {this.saleValue = e.dateStart}"/>
          </div>
          <div class="ml-4" style="display: inline-block">
            <b style="display: inline-block">Last Contacted:</b>
            <v-select class="ml-2" style="display: inline-block; width: 50px" :items="['<=', '>=', '=']"  v-model="contactedCondition"/>
            <DateFilter class="ml-2" style="display: inline-block;" @getDates="(e) => {this.contactedValue = e.dateStart}"/>
          </div>

        </div>
        <div class="mb-2">
          <div class="mt-3 ml-4" style="display: inline-block">
            <v-btn
              color="#3F51B5"
              dark
              depressed
              height='40'
              min-width='40'
              @click="filters"
            >
                Apply
            </v-btn>
          </div>
        </div>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
      <v-card-title>
        <v-row class="pa-0">                
          <v-col cols="12" class="d-flex justify-end pb-0 pt-0 mt-0 mt-md-4">
            <v-spacer></v-spacer>
            <vue-excel-xlsx
              :data="dataForExcel"
              :columns="columnsData"
              :filename="'All Customers Report'"
              :sheetname="'All Customers Report'"
            >
              <v-btn
                height="39"           
                min-width="39px"        
                :disabled="dataFiltered.length === 0"
                class="ml-auto mr-5 rounded-lg px-0"                           
                color="white"
              >
                <ExportExcel />
              </v-btn> 
            </vue-excel-xlsx>
            <CustomColumns
              :currentValue="value"
              :currentCustomHeader="customHeader"
              :currentHeaders="headers"
              :settingsName="settingsName"
              @getCustomData="getCustomData"
            />
          </v-col>
        </v-row>
      </v-card-title> 
      <v-hover v-model="hoverOnTable">
        <v-card-text>
          <div class="d-flex justify-space-between nav">
            <v-btn
                class="mx-2 scroll-btn btn-left-arrow"
                fab
                small
                @click="scrollingLeft"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
                class="mx-2 scroll-btn btn-right-arrow"
                fab
                small
                @click="scrollingRight"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
              v-model="selected"
              :headers="selectedHeaders"
              :items="dataFiltered"
              item-key="id"
              class="elevation-0 mt-2 table-main-container"
              fixed-header
              height="538"
              :loading="loaded"
              loading-text="Loading... Please wait"
              :search="search"
              :page.sync="pagination.page"
              :custom-sort="customSort"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 75, 100, -1]
                }"
              @click:row="rowClick"
          >
            <template v-slot:item.full_name="{ item }">
              <span v-if="item.copper_people_id>0"><a target="_blank" :href="`https://app.copper.com/companies/243221/app/#/contact/`+item.copper_people_id ">{{ item.full_name }}</a></span>
              <span v-else>{{ item.full_name }}</span>
            </template>
            <template v-slot:item.sent_date="{ item }">
              <span v-if="item.sent_date">{{ new Date(item.sent_date).toLocaleString() }}</span>
              <span v-else> - </span>
            </template>
            <template v-slot:item.last_sale_date="{ item }">
              <span v-if="item.last_sale_date" >{{ new Date(item.last_sale_date).toLocaleString() }}</span>
              <span v-else> - </span>
            </template>
            <template v-slot:item.orders_ct="{ item }">
              <a v-if="item.orders_ct>0"  @click="redirectToSalesReport(item)">{{ item.orders_ct }}</a>
              <span v-else>0</span>
            </template>
            <template v-slot:item.last_contact_date_str="{ item }">
              <span v-if="item.last_contact_date_str == '01/01/1900'">-</span>
               <span v-else>{{item.last_contact_date_str}}</span>
            </template>
            <template v-slot:item.last_activity_record="{ item }">
              <div v-if="item.last_activity_record.date !== ''">
                <p style="margin-bottom: 0">Date: {{item.last_activity_record.date}}</p>
                <p style="margin-bottom: 0"><b>{{item.last_activity_record.title}}</b></p>
                <p style="margin-bottom: 0">{{item.last_activity_record.content}}</p>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-hover>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import CustomColumns from '@/components/customizing/CustomColumns'
import ExportExcel from '@/components/customizing/ExportExcel'
import moment from "moment";
import DateFilter from '@/components/filters/DateFilter'

export default {
  components: {
    CustomColumns,
    ExportExcel,
    DateFilter
  },
  data() {
    return {
      hiddenAdditionalFilters: true,

      orderCondition: '>=',
      orderValue: '',
      gallonCondition: '>=',
      gallonValue: '',
      inactivityCondition: '>=',
      inactivityValue: '',
      saleCondition: '>=',
      saleValue: '',
      contactedCondition: '>=',
      contactedValue: '',

      selected: [],
      search: '',
      headers: [
        {text: 'Full Name', value: 'full_name', class: 'black--text'},
        {text: 'Company', value: 'company_name', class: 'black--text'},
        {text: 'Copper Company', value: 'copper_company_name', class: 'black--text'},
        {text: 'All Unique Emails ', value: 'all_emails', class: 'black--text'},
        {text: 'CallRail phone', value: 'call_rail_phone', class: 'black--text'},
        {text: 'All Unique Phones', value: 'all_phones', class: 'black--text'},
        {text: '# of orders', value: 'orders_ct', class: 'black--text'},
        {text: 'Total # of gallons', value: 'total_gallons', class: 'black--text'},
        {text: 'Last Sale', value: 'last_sale_date_str', class: 'black--text'},
        {text: 'Last Contacted', value: 'last_contact_date_str', class: 'black--text'},
        {text: 'Inactivity Days', value: 'inactive_days', class: 'black--text'},
        {text: 'Interactions', value: 'interaction_count', class: 'black--text'},
        {text: 'Copper Owner', value: 'copper_owner', class: 'black--text'},
        {text: 'Last Activity Record', value: 'last_activity_record', class: 'black--text'}
      ],
      customHeader: ['full_name', 'company_name', 'copper_company_name', 'all_emails', 'call_rail_phone', 'all_phones',
        'orders_ct', 'total_gallons', 'last_sale_date_str', 'last_contact_date_str', 'inactive_days', 'interaction_count',
        'copper_owner', 'last_activity_record'],
      selectedHeaders: [],
      value: [
        {text: 'Full Name', value: 'full_name', class: 'black--text'},
        {text: 'Company', value: 'company_name', class: 'black--text'},
        {text: 'Copper Company', value: 'copper_company_name', class: 'black--text'},
        {text: 'All Unique Emails ', value: 'all_emails', class: 'black--text'},
        {text: 'CallRail phone', value: 'call_rail_phone', class: 'black--text'},
        {text: 'All Unique Phones', value: 'all_phones', class: 'black--text'},
        {text: '# of orders', value: 'orders_ct', class: 'black--text'},
        {text: 'Total # of gallons', value: 'total_gallons', class: 'black--text'},
        {text: 'Last Sale', value: 'last_sale_date_str', class: 'black--text'},
        {text: 'Last Contacted', value: 'last_contact_date_str', class: 'black--text'},
        {text: 'Inactivity Days', value: 'inactive_days', class: 'black--text'},
        {text: 'Interactions', value: 'interaction_count', class: 'black--text'},
        {text: 'Copper Owner', value: 'copper_owner', class: 'black--text'},
        {text: 'Last Activity Record', value: 'last_activity_record', class: 'black--text'}
      ],
      settingsName: 'allCustomers',
      data: [],
      dataFiltered: [],
      dataOrigin: [],
      columnsData: [],
      selectedRows: [],
      userName: null,
      loaded: false,
      dialogCustomColumns: false,
      scrollLeft: 0,
      scrollWidth: 0,
      clientWidth: 0,
      hoverOnTable: false,
      pagination: {
        page: 1
      }
    }
  },
  watch: {
    data() {
      this.pagination.page = 1
    },
    value(val) {
      this.selectedHeaders = val
      this.getHeaderForExcel()
    },
    hoverOnTable(){
      this.showScrollingArrows()
    },
    hiddenAdditionalFilters(val){
      if (val === true) {
        this.saleValue = '';
        this.contactedValue = '';
        this.filters()
      }
    }
  },
  created() {
    this.selectedHeaders = this.value
    this.getHeaderForExcel()
    window.addEventListener("resize", this.showScrollingArrows)
  },
  destroyed() {
    window.removeEventListener("resize", this.showScrollingArrows)
  },
  mounted() {

    axios
        .get('/username')
        .then(response => (this.userName = response.data))

    let userName = localStorage.getItem('username')
    let settings = this.settingsName
    let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1
    if (localStorage.getItem(`${userName}.${clientId}.${settings}`)) {

      try {

        let valueCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${settings}`))
        this.value = valueCash.filter(e => this.headers.find(item => item.value === e.value))

        const parsed = JSON.stringify(this.value)
        localStorage.setItem(`${userName}.${clientId}.${settings}`, parsed)

        this.customHeader = this.value.map(e => e.value)
      } catch (e) {
        console.log("")
      }
    }

    this.applyFilters()
    this.showScrollingArrows()
  },
  methods: {
    customSort: function(items, index, isDesc) {
      items.sort((a, b) => {
          if (index[0]=='last_contact_date_str' || index[0]== 'last_sale_date_str') {
            if (!isDesc[0]) {
                return new Date(b[index]) - new Date(a[index]);
            } else {
                return new Date(a[index]) - new Date(b[index]);
            }
          }
          else {
            if(typeof a[index] === 'number' && typeof b[index] === 'number'){
              if (!isDesc[0]) {
                 return a[index] - b[index];
              }
              else {
                  return b[index] - a[index]
              }
            }else{
              let av = "-"
              if (a[index] !== null && a[index] !== undefined){
                av = a[index].toString()
              }
              let bv = "-"
              if (b[index] !== null && b[index] !== undefined){
                bv = b[index].toString()
              }

              if (!isDesc[0]) {
                 return av.toLowerCase().localeCompare(bv.toLowerCase());
              }
              else {
                  return bv.toLowerCase().localeCompare(av.toLowerCase());
              }
            }
          }
      });
      return items;
    },
    scrollingRight() {
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft + 50

      const btnRight = document.querySelector('.btn-right-arrow')
      const btnLeft = document.querySelector('.btn-left-arrow')
      btnRight.style.visibility = (this.hoverOnTable && (el.scrollLeft + el.clientWidth != el.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    scrollingLeft() {
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left-arrow')
      const btnRight = document.querySelector('.btn-right-arrow')
      btnLeft.style.visibility = (this.hoverOnTable && (el.scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    showScrollingArrows() {
      const el = document.querySelector('.v-data-table__wrapper')
      this.scrollLeft = el.scrollLeft
      this.scrollWidth = el.scrollWidth
      this.clientWidth = el.clientWidth

      const btnRight = document.querySelector('.btn-right-arrow')
      const btnLeft = document.querySelector('.btn-left-arrow')
      btnRight.style.visibility = (this.hoverOnTable && (this.scrollLeft + this.clientWidth !== this.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = (this.hoverOnTable && (this.scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    rowClick: function (item, row) {     
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    },
    getHeaderForExcel(){
      this.columnsData = this.selectedHeaders.map(e => {
          const obj = {}
          if (e.value !== "actions") {
              obj.label = e.text
              obj.field = e.value
          }
          return obj
      }).filter(value => Object.keys(value).length !== 0)
    },
    applyFilters() {
      this.loaded = true
      axios
          .get(`/reports/all-customers`)
          .then(response => {
            this.data = response.data.data
            this.dataFiltered = JSON.parse(JSON.stringify(this.data))

            this.loaded = false
          })
    },
    filters() {
      this.dataFiltered = JSON.parse(JSON.stringify(this.data))

      if (this.orderValue !== '') {
        switch (this.orderCondition){
          case ">=":
            this.dataFiltered = this.dataFiltered.filter(el => el.orders_ct >= this.orderValue)
            break;
          case "<=":
            this.dataFiltered = this.dataFiltered.filter(el => el.orders_ct <= this.orderValue)
            break;
          case "=":
            this.dataFiltered = this.dataFiltered.filter(el => el.orders_ct == this.orderValue)
            break
        }
      }
      if (this.gallonValue !== '') {
        switch (this.gallonCondition){
          case ">=":
            this.dataFiltered = this.dataFiltered.filter(el => el.total_gallons >= this.gallonValue)
            break;
          case "<=":
            this.dataFiltered = this.dataFiltered.filter(el => el.total_gallons <= this.gallonValue)
            break;
          case "=":
            this.dataFiltered = this.dataFiltered.filter(el => el.total_gallons == this.gallonValue)
            break
        }
      }
      if (this.inactivityValue !== '') {
        switch (this.inactivityCondition){
          case ">=":
            this.dataFiltered = this.dataFiltered.filter(el => el.inactive_days >= this.inactivityValue)
            break;
          case "<=":
            this.dataFiltered = this.dataFiltered.filter(el => el.inactive_days <= this.inactivityValue)
            break;
          case "=":
            this.dataFiltered = this.dataFiltered.filter(el => el.inactive_days == this.inactivityValue)
            break
        }
      }
      if (this.saleValue !== '' && this.saleValue !== null) {
        switch (this.saleCondition){
          case ">=":
            this.dataFiltered = this.dataFiltered.filter(el => moment(el.last_sale_date_str).unix() >= moment(this.saleValue).unix())
            break;
          case "<=":
            this.dataFiltered = this.dataFiltered.filter(el => moment(el.last_sale_date_str).unix() <= moment(this.saleValue).unix())
            break;
          case "=":
            this.dataFiltered = this.dataFiltered.filter(el => moment(el.last_sale_date_str).unix() === moment(this.saleValue).unix())
            break
        }
      }

      if (this.contactedValue !== '' && this.contactedValue !== null) {
        switch (this.contactedCondition){
          case ">=":
            this.dataFiltered = this.dataFiltered.filter(el => moment(el.last_contact_date_str).unix() >= moment(this.contactedValue).unix())
            break;
          case "<=":
            this.dataFiltered = this.dataFiltered.filter(el => moment(el.last_contact_date_str).unix() <= moment(this.contactedValue).unix())
            break;
          case "=":
            this.dataFiltered = this.dataFiltered.filter(el => moment(el.last_contact_date_str).unix() === moment(this.contactedValue).unix())
            break
        }
      }

    },
    cleanFilters(){
      this.search = ''
    },
    getCustomData({customHeader, value, selectedHeaders}){
      this.customHeader = customHeader
      this.value = value
      this.selectedHeaders = selectedHeaders
    },
    redirectToSalesReport(item){
      let dateStart = new Date().toISOString().substr(0, 10);
      let dateEnd = moment().subtract(10, "years").format("YYYY-MM-DD");

      let orders = JSON.stringify({report: 'SendInBlueReport',
                                  order_ids: item.order_ids.map(e => +e),
                                  dateStart: dateEnd,
                                  dateEnd: dateStart,
                                  defaultPeriod: 9,
                                  search: item.name
                                  })
      localStorage.setItem('orders', orders)
      let routeData = this.$router.resolve({ name: 'sales'})
      window.open(routeData.href, '_blank')
    },
  },
  computed: {
    dataForExcel(){
      if (!this.dataFiltered) return []
      let data = JSON.parse(JSON.stringify(this.dataFiltered))
      data.map(e => {
        e.sent_date = (e.sent_date) ? new Date(e.sent_date).toLocaleString() : '-'
        e.last_sale_date = (e.last_sale_date) ? new Date(e.last_sale_date).toLocaleString() : '-'
      })
      return data 
    },    
  }
}
</script>

<style scoped>
  .btn-right-arrow {
    right: 0px;
    top: 70px;
  }

  .btn-left-arrow {
    left: 0px;
    top: 70px;
  }
</style>